<template>
  <div class="d-inline-block">
    <b-input-group>
      <b-input-group-prepend @click="$refs.PdvSalesmanSearch.open()" is-text>
        <i class="fas fa-user-tie" />
      </b-input-group-prepend>
      <b-form-input
        id="customerName"
        @click="$refs.PdvSalesmanSearch.open()"
        readonly
        :value="salesman.name"
      />
      <b-input-group-append v-if="salesman.id">
        <b-button @click="removeSalesman()" variant="success"
          ><i class="  fas fa-times"
        /></b-button>
      </b-input-group-append>
    </b-input-group>
    <PdvSalesmanSearch ref="PdvSalesmanSearch" @input="setSalesman($event)" />
  </div>
</template>

<script>
import PdvSalesmanSearch from "@/components/pdv/sections/PdvSalesmanSearch.vue";

export default {
  components: {
    PdvSalesmanSearch
  },
  mounted() {
    this.setDefaultSalesman();
  },
  computed: {
    salesman() {
      return this.$store.getters["orderForm/salesman"];
    },
    order() {
      return this.$store.state.orderForm.order;
    },

    defaultSalesman() {
      return this.$store.state.user.salesman;
    }
  },
  methods: {
    setDefaultSalesman() {
      if (this.defaultSalesman) {
        this.setSalesman(this.defaultSalesman);
      }
    },
    setSalesman(salesman) {
      this.$store.commit("orderForm/setSalesman", salesman);
    },
    removeSalesman() {
      this.$store.commit("orderForm/removeSalesman");
    }
  }
};
</script>

<style></style>
